import React from 'react';
import SvgOverviewIcon from '../icons/svgOverviewIcon';
import SvgRegisterIcon from '../icons/svgRegisterIcon';
import SvgSessionsIcon from '../icons/svgSessionsIcon';
import SvgPeopleIcon from '../icons/svgPeopleIcon';
import SvgSettingsIcon from '../icons/svgSettingsIcon';
import SvgBrandingIcon from '../icons/svgBrandingIcon';
import SvgAnalyticsIcon from '../icons/svgAnalyticsIcon';
import SvgEmailIcon from '../icons/svgEmailIcon';
import SvgIntegrationIcon from '../icons/svgIntegrationIcon';
import SvgEngagementIcon from '../icons/svgEngagementIcon';
import SvgContentHubIcon from '../icons/svgContentHubIcon';
import SvgLandingPageIcon from '../icons/svgLandingPageIcon';

export const getWebinarNavLinks = (isWebinarPlus) => [
  {
    id: 0,
    name: 'Overview',
    icon: <SvgOverviewIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/',
  },
  {
    id: 4,
    name: 'People',
    icon: <SvgPeopleIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/people',
  },
  {
    id: 2,
    name: 'Registration',
    icon: <SvgRegisterIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/registration',
    isSubMenuOpen: false,
    subMenu: [
      {
        name: 'Setup Form',
        hasEventIdAndOrganiserId: true,
        url: '/registration/setup-form',
        communityVersion: 2,
      },
      // {
      //   name: 'Landing Page',
      //   hasEventIdAndOrganiserId: true,
      //   url: '/registration/landing-page',
      //   communityVersion: 2,
      // },
      {
        name: 'UTM code',
        hasEventIdAndOrganiserId: true,
        url: '/registration/utm',
        communityVersion: 2,
      },
    ],
    isShow: true,
  },

  {
    id: 18,
    name: 'Landing',
    icon: <SvgLandingPageIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/registration/landing-page',
    communityVersion: 2,
  },

  {
    id: 3,
    name: 'Session',
    icon: <SvgSessionsIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/sessions',
    subUrl: '/session',
  },
  {
    id: 17,
    name: 'Emails',
    icon: <SvgEmailIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/email-builder',
    inPersonDisabledView: true,
  },
  {
    id: 9,
    name: 'Engagement',
    icon: <SvgEngagementIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/engagement',
    isSubMenuOpen: false,
    subMenu: [
      {
        name: 'Lead Score',
        hasEventIdAndOrganiserId: true,
        url: '/engagement/lead-score',
      },
      {
        name: 'Survey',
        hasEventIdAndOrganiserId: true,
        url: '/engagement/survey',
      },
      {
        name: 'Quiz',
        hasEventIdAndOrganiserId: true,
        url: '/engagement/quiz',
      },
    ],
  },

  // {
  //   id: 10,
  //   name: 'Branding',
  //   icon: <SvgBrandingIcon height="18px" width="18px" />,
  //   hasEventIdAndOrganiserId: true,
  //   url: '/brand-your-events',
  //   // isShow: true,
  //   // isSubMenuOpen: false,
  //   // subMenu: [
  //   //   {
  //   //     name: 'BRAND YOUR EVENT',
  //   //     hasEventIdAndOrganiserId: true,
  //   //     url: '/brand-your-events',
  //   //   },
  //   // ],
  // },
  {
    id: 12,
    name: 'Analytics',
    icon: <SvgAnalyticsIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/analytics/registration',
    subUrl: '/analytics',
  },
  {
    id: 13,
    name: 'Integrations',
    icon: <SvgIntegrationIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/integrations/connected-apps',
    // isShow: true,
    // isSubMenuOpen: false,
    // subMenu: [
    //   {
    //     name: 'Connected Apps',
    //     hasEventIdAndOrganiserId: true,
    //     url: '/integrations/connected-apps',
    //   },
    // ],
  },
  // {
  //   id: 13,
  //   name: 'Settings',
  //   icon: <SvgSettingsIcon height="18px" width="18px" />,
  //   hasEventIdAndOrganiserId: true,
  //   url: '/settings/login-options',
  //   // keyDivider: true,
  //   subUrl: '/settings',
  // },
  {
    id: 14,
    name: 'Settings',
    icon: <SvgSettingsIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/settings/login-options',
    keyDivider: false,
    subUrl: '/settings',
    subMenu: [
      {
        id: 20,
        name: isWebinarPlus ? 'Webinar Settings' : 'Event Settings',
        hasEventIdAndOrganiserId: true,
        url: '/settings/login-options',
      },
      {
        id: 10,
        name: 'Branding',
        icon: <SvgBrandingIcon height="18px" width="18px" />,
        hasEventIdAndOrganiserId: true,
        url: '/brand-your-events',
        // isShow: true,
        // isSubMenuOpen: false,
        // subMenu: [
        //   {
        //     name: 'BRAND YOUR EVENT',
        //     hasEventIdAndOrganiserId: true,
        //     url: '/brand-your-events',
        //   },
        // ],
      },
      {
        id: 15,
        name: 'Recordings',
        hasEventIdAndOrganiserId: true,
        url: '/recording',
        inPersonDisabledView: true,
      },
      {
        id: 16,
        name: 'File Logs',
        hasEventIdAndOrganiserId: true,
        url: '/file-logs',
      },
    ],
  },
  // {
  //   id: 14,
  //   name: 'Recording',
  //   icon: <SvgRecordingIcon height="18px" width="18px" />,
  //   hasEventIdAndOrganiserId: true,
  //   url: '/recording',
  //   inPersonDisabledView: true,
  // },
  {
    id: 16,
    name: isWebinarPlus ? 'Content Creator' : 'Content Hub',
    icon: <SvgContentHubIcon height="18px" width="18px" />,
    // isNew:true,
    hasEventIdAndOrganiserId: true,
    url: 'content-hub',
    inPersonDisabledView: true,
    isInMonoRepo: true,
  },
  // {
  //   id: 15,
  //   name: 'File Logs',
  //   icon: <SvgFileLogsIcon height="18px" width="18px" />,
  //   hasEventIdAndOrganiserId: true,
  //   url: '/file-logs',
  // },
];
